
export default {
  props: {
    fixture: {
      type: Object,
      required: true,
    },
    userScore: {
      type: Array,
      required: true,
    },
  },
  data () {
    return {
      modalOpen: false,
      shareUrl: ``,
    };
  },
  computed: {
    realScore () {
      return this.getFixtureScore(this.fixture);
    },
    homeTeam () {
      return this.getTeam(this.fixture, `Home`);
    },
    awayTeam () {
      return this.getTeam(this.fixture, `Away`);
    },
    shareText () {
      let share = `I predict ${this.homeTeam.team.teamNames[0].displayName} ${this.homeScore} - ${this.awayScore} ${this.awayTeam.team.teamNames[0].displayName}`;
      share += ` Have Your Say #AberdeenFC`;
      return share;
    },
  },
  mounted () {
    this.$nextTick(() => {
      this.shareUrl = window.location.href;
    });
  },
  methods: {
    shareResult () {
      this.modalOpen = true;
    },
    getDifference (side) {
      const diff = side === `home`
        ? parseInt(this.userScore[0]) - parseInt(this.realScore.home)
        : parseInt(this.userScore[1]) - parseInt(this.realScore.away);
      return diff === 0 ? false : diff > 0 ? `+${diff}` : diff;
    },
    getDifferenceClass (side) {
      const diff = side === `home`
        ? parseInt(this.userScore[0]) - parseInt(this.realScore.home)
        : parseInt(this.userScore[1]) - parseInt(this.realScore.away);

      if (diff === 0) {
        return `bg-green c-greentint`;
      } else if (diff <= 1 && diff >= -1) {
        return `bg-greentint c-white`;
      }
      return `bg-primary c-redtint`;
    },
  },
};
